@if (labelSwitcherService.currentLabelItem(); as currentLabelItem) {
    @if (useFastIconType) {
        <vn-menu-item
            [item]="item"
            [section]="MenuSection.NewVisitorPage"
            [text]="currentLabelItem?.text"
            [processClick]="false"
            (click)="processClick($event, item)"
            [displayMode]="MenuDisplayMode.FastIcon" />
    } @else {
        <vn-menu-item
            [item]="item"
            [section]="MenuSection.NewVisitorPage"
            [text]="currentLabelItem?.text"
            [processClick]="false"
            (click)="processClick($event, item)"
            [displayMode]="MenuDisplayMode.Icon" />
    }
}
